import React from "react"
import { useSelector } from "react-redux"
import { getIsWorkflowFormVisible } from "reduxSlices/formBuilderSlice"
import WorkflowList from "./WorkflowList"
import WorkflowHeader from "./WorkflowHeader"
import WorkflowForm from "./WorkflowForm"

const WorkflowsTab = () => {
  const isWorkflowFormVisible = useSelector(getIsWorkflowFormVisible)

  if (isWorkflowFormVisible) {
    return <WorkflowForm />
  }

  return (
    <div className="inner-container w-full max-w-screen-xl mx-auto">
      <WorkflowHeader />
      <WorkflowList />
    </div>
  )
}

export default WorkflowsTab
